import { createReducer, isAnyOf } from "@reduxjs/toolkit";
import { omit } from "lodash";
import initialState from "./process-data-list.store";
import { setKnowledgeBaseItemsFilterExcludedTags, setKnowledgeBaseItemsFilterIncludedTags, setKnowledgeBaseItemsLastUsedSortingDirection, setKnowledgeBaseItemsNameSortingDirection, setKnowledgeBaseItemsOwnershipFilter, setKnowledgeBaseItemsSearchQuery, } from "store/knowledge-base-items-list/knowledge-base-items-list.actions";
import { GlobalEntityType } from "shared/types";
import { loadProcessDataList, loadProcessDataListFailure, loadProcessDataListSuccessful, } from "./process-data-list.actions";
import { revokeOwnershipSuccessful, shareOwnershipSuccessful, } from "store/knowledge-base-item/knowledge-base-item.actions";
export default createReducer(initialState, (builder) => {
    builder
        .addCase(loadProcessDataList, (state) => {
        state.loading = true;
    })
        .addCase(loadProcessDataListSuccessful, (state, { payload }) => {
        state.items = payload;
        state.loading = false;
    })
        .addCase(loadProcessDataListFailure, (state) => {
        state.loading = false;
    })
        .addCase(setKnowledgeBaseItemsSearchQuery, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.ProcessData) {
            state.searchQuery = payload.query;
        }
    })
        .addCase(setKnowledgeBaseItemsOwnershipFilter, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.ProcessData) {
            state.ownershipFilter = payload.ownershipFilter;
        }
    })
        .addCase(setKnowledgeBaseItemsNameSortingDirection, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.ProcessData) {
            state.sortingDirections.name = payload.direction;
        }
    })
        .addCase(setKnowledgeBaseItemsLastUsedSortingDirection, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.ProcessData) {
            state.sortingDirections.lastUsed = payload.direction;
        }
    })
        .addCase(setKnowledgeBaseItemsFilterIncludedTags, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.ProcessData) {
            state.tagsFilters.included = payload.tags;
        }
    })
        .addCase(setKnowledgeBaseItemsFilterExcludedTags, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.ProcessData) {
            state.tagsFilters.excluded = payload.tags;
        }
    })
        .addMatcher(isAnyOf(shareOwnershipSuccessful, revokeOwnershipSuccessful), (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.ProcessData) {
            const existingItem = state.items.find(({ id }) => id === payload.knowledgeBaseItem.id);
            state.items = [
                ...state.items?.filter(({ id }) => id !== payload.knowledgeBaseItem.id),
                { ...existingItem, ...omit(payload.knowledgeBaseItem, "state") },
            ];
        }
    });
});
